export const breakpointSm = "600px";
export const breakpointMd = "905px";
export const breakpointLg = "1240px";
export const breakpointXl = "1440px";

export const sectionWidth = "800px";
export const sectionContentWidth = "600px";
